// extracted by mini-css-extract-plugin
export default {"root":"ProvidersDetails_root__75dIT","tile":"ProvidersDetails_tile__wD5Ti","indexIcon":"ProvidersDetails_indexIcon__3yiVR"};